import { render, staticRenderFns } from "./EventTemplateList.vue?vue&type=template&id=4f1ec953&scoped=true&"
import script from "./EventTemplateList.vue?vue&type=script&lang=js&"
export * from "./EventTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ec953",
  null
  
)

export default component.exports